import { PACK_PRICE_LABEL, PRODUCTS, type AppConfig, type EntitlementsView } from '@shared/game/types';
import { Avatar } from './Avatar';
import { Dice } from './Dice';
import { Icon } from './Icon';
import { Modal } from './Modal';

interface ShopModalProps {
  open: boolean;
  onClose: () => void;
  config: AppConfig | null;
  entitlements: EntitlementsView;
  onCheckout: () => void;
  checkoutBusy: boolean;
}

export function ShopModal({ open, onClose, config, entitlements, onCheckout, checkoutBusy }: ShopModalProps) {
  const product = PRODUCTS.voyager;
  const owned = entitlements.products.includes('voyager');
  const priceLabel = PACK_PRICE_LABEL;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Pack del Viajero Astral"
      subtitle="Apoya el proyecto sin comprar ventajas. Todo lo que hay aquí es decorativo."
      wide
    >
      <div className="shop">
        <div className="shop__showcase">
          <div className="shop__orb" />
          <div className="shop__avatars">
            <div className="shop__avatar-preview">
              <Avatar avatar="solstice" size={108} />
              <span className="shop__avatar-badge"><Icon name="star" size={11} /> Primer explorador</span>
            </div>
            <Avatar avatar="oracle" size={108} />
          </div>
          <div className="shop__dice">
            <Dice value={6} skin="aurora" animations={false} size="small" effect="astral" />
            <Dice value={3} skin="aurora" animations={false} size="small" effect="astral" />
          </div>
          <span className="shop__badge"><Icon name="star" size={13} /> Pack cosmético</span>
        </div>

        <div className="shop__info">
          <span className="eyebrow">Edición del primer explorador</span>
          <h3>{product.name}</h3>
          <p>{product.description}</p>
          <p className="shop__value">
            Apoya el proyecto y desbloquea la edición cosmética del Viajero Astral.
          </p>
          <div className="shop__price">
            <span>{priceLabel}</span>
            <small>Pago seguro con Stripe</small>
          </div>
          <div className="shop__section-title">Incluye</div>
          <ul className="shop__includes">
            {product.includes.map((item) => (
              <li key={item}><Icon name="check" size={15} /> {item}</li>
            ))}
          </ul>
          <div className="shop__no-advantages">
            <Icon name="shield" size={15} />
            <div>
              <strong>No incluye ventajas de juego</strong>
              <span>Sin más dados, movimientos, capturas ni ventajas competitivas. Solo cosméticos.</span>
            </div>
          </div>

          {owned ? (
            <div className="shop__owned">
              <Icon name="check" size={18} /> Ya tienes este pack vinculado a tu sesión.
            </div>
          ) : (
            <button
              type="button"
              className="button button--primary button--full shop__cta"
              onClick={onCheckout}
              disabled={!config?.paymentsEnabled || checkoutBusy}
            >
              <Icon name="bag" size={17} />
              {checkoutBusy ? 'Abriendo pago…' : 'Comprar pack cosmético'}
            </button>
          )}

          {!config?.paymentsEnabled && (
            <div className="notice notice--warning">
              <Icon name="lock" size={16} />
              <span>Los pagos no están disponibles en este momento. Vuelve a intentarlo pronto.</span>
            </div>
          )}

          <p className="shop__fineprint">
            Tu compra se guarda de forma segura en este navegador y desbloquea los cosméticos.
            No ofrece ventajas competitivas ni cambia las reglas.
          </p>
        </div>
      </div>
    </Modal>
  );
}
